import { Component, OnInit, ViewChild, OnDestroy, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
//import { AdalService } from 'ng2-adal/dist/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { StorageRouterService } from '../services/storage-router.service';
import { Settings } from '../flows/settings';
//import { AnalyticsService } from '../services/analytics.service';
import { MsalHelperService } from '../services/msal-helper.service';
import { environment } from '../../environments/environment';
import { TabStripComponent, TabStripModule, SelectEvent } from '@progress/kendo-angular-layout';
import { FlowManagementService } from '../services/flow-management.service';
import { Subscription, ReplaySubject } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { filter, shareReplay } from 'rxjs/operators';
import { ApplicationInsightsService } from '../services/application-insights.service';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WelcomeComponent implements OnInit, OnDestroy, AfterViewInit {

    ready: boolean = false;
    hasUser: boolean = false;

    environmentSubscription: Subscription;
    readonly PRODUCT_NAME = `FlowStudio`;

    @ViewChild('tabStrip', {static: true}) tabStrip: TabStripComponent;

    resLayout: ('desktop' | 'mobile' | 'mobile-topics')  = 'desktop';  // 
    path: string = null;

    tabs = [
        '',
        'flow-studio-app',
        'discover',
        'sort',
        'tags',
        'migrate',
        'admin',
        'sparklines',
        'edit',
        'versioning',
        'search',
        'export',
        'flow-studio-pricing',
        'change-log',
        'power-governance',
        'mentoring',
        'privacy',
        'security',
        'terms'
    ]

    constructor(
        private router: Router, 
        private route: ActivatedRoute,
        private msalHelperService: MsalHelperService,
        private storageDexieService: StorageRouterService,
        //private analytics: AnalyticsService,
        private appInsights: ApplicationInsightsService,
        private flowManagementService: FlowManagementService,
        private breakpointObserver: BreakpointObserver
    ) {

        this.router.events.pipe(
            filter( (e): e is NavigationEnd => e instanceof NavigationEnd),
            shareReplay(1)
        ).subscribe((end)=>{

            console.log('navigated')
            this.route.url.subscribe(segments => {
                let segment = segments[segments.length - 1];
                this.path = segment.path;
            });
        });
    }

    ngOnInit() {
        if (!this.msalHelperService.getUser()) {
            //this.router.navigate(['login']);
            //this.analytics.send("app", "welcome");
            //this.appInsights.logPageView(`app: welcome`);
            this.appInsights.trackEvent(`app`, { "select": "welcome" });
            this.ready = true;                
            // setTimeout(() => {
            // }, 5000);
        }
        else {

            let result = this.msalHelperService.getCachedTokenInternal(['https://management.azure.com/user_impersonation']);
            if (result && result.token) {
                this.hasUser = true;
            }    

        //     this.getLastRoute().then(route=>{
        //         //this.ready = true;                
        //         this.router.navigate([route]);
        //     });
        //     // this.adalService.acquireToken("https://management.azure.com/").toPromise().then(()=>{
        //     // });
            //this.welcomeBack();
        }

        this.environmentSubscription = this.flowManagementService.currentEnvironment$.subscribe((environment)=>{
            if (environment) {
                this.hasUser = true;
            }
        })

        this.breakpointObserver
            .observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
            .subscribe((state: BreakpointState) => {
                if (state.matches) {

                console.log(
                    'Matches small viewport or handset in portrait mode'
                );
                }

                this.resLayout = state.matches ? 'mobile' : 'desktop';
            }
        );

        //this.welcome();
    }

    ngAfterViewInit() {
        //view child tabstrip only available at this point
        setTimeout(()=>{
            this.selectTab();
        }, 1);
    }

    ngOnDestroy() {
        if (this.environmentSubscription) {
            this.environmentSubscription.unsubscribe();
        }
    }

    // async welcome() {
    //     //let version = await this.storageDexieService.getSetting(Settings.SETTING_LASTVERSION);

    //     // if (version.value == environment.VERSION) {
    //     //     this.tabStrip.selectTab(this.tabStrip.tabs.length-1);
    //     // }
    // }

    ngOnLoad() {

    }

    // async getLastRoute() {
    //     var setting = await this.storageDexieService.getSetting(Settings.SETTING_LASTROUTE);
    //     return setting.value || "/flows";
    // }

    public items: any[] = [
        { title: 'Filter by Flow Trigger', url: 'https://i.imgur.com/L8kygnw.png' },
        { title: 'Order by Runs or Last Ran', url: 'https://i.imgur.com/mZktY6o.png' },
        { title: 'Add meta-tags and Filter Sets by Tag', url: 'https://i.imgur.com/xBZaHJ2.png' },
        { title: 'Duplicate a Flow', url: 'https://i.imgur.com/mWqeRx8.png'},
        { title: 'Edit Flow JSON', url: 'https://i.imgur.com/4xlnM9q.png'},
        { title: 'Filter Failed Runs', url: 'https://i.imgur.com/45rGgnU.png'},
        { title: 'Sort Runs by duration', url: 'https://i.imgur.com/waE3spR.png'},
        { title: 'Take you right into your Flow', url: 'https://i.imgur.com/U21DMQl.png'}
    ];
    public width = '800px';
    public height = '600px';

    login($event) {
        $event.stopPropagation();
        //this.analytics.send("app", "login");
        //this.appInsights.logPageView(`app: login`);
        this.appInsights.trackEvent(`app`, { "select": "login" });
        // this.msalHelperService.login();
        this.router.navigate(['login']);
    }

    welcomeBack($event) {
        $event.stopPropagation()
        this.storageDexieService.getConfig(Settings.SETTING_LASTROUTE).then(setting=>{
            let route = setting?.value || "/flows";
            if (route === '/' || route.startsWith('/settings')) {
                route = '/flows';
            }

            this.msalHelperService.continueLogin(route);
        })

        // this.getLastRoute().then(route=>{
        //     //this.ready = true;                
        // });    
    }

    get showTopics() {
        return this.resLayout == 'mobile-topics';
    }

    set showTopics(show: boolean) {
        console.log(show);

        if (this.resLayout == 'desktop') {
            return;
        }
        this.resLayout = show ? 'mobile-topics' : 'mobile';
    }

    navigate(url: string) {
        this.router.navigateByUrl(url);
        setTimeout(()=>{
            this.selectTab();
        },1);
    }

    onTabSelect(e: SelectEvent) {
        try {
            let path = this.tabs[e.index];
            if (path != this.path) {
                this.navigate(`/welcome/about${path ? '/'+path : ''}`);
            }
        }
        catch(ex) {

        }
    }

    selectTab() {
        let index = this.tabs.indexOf(this.path);

        if (index >= 0) {
            console.log('selectTab')
            this.tabStrip.selectTab(index);
        }
    }

    // login() {
    //     this.adalService.login();
    // }

    // logout() {
    //     this.adalService.logOut();
    // }

    // public get isLoggedIn() {
    //     return this.adalService.userInfo && this.adalService.userInfo.isAuthenticated;
    // }
}
